import { Button } from "@mui/material"
import { store } from "../../../stores/Store"
import { AlertModal, DisplayValue } from "../../.."
import { AccountEditForm } from "../../form/admin/AccountForms"
import AccountUsers from "../account/AccountUsers"
import IsAllowed from "../../../models/Permissions"
import DeleteForm from "../../form/case/DeleteForm"
import AccountQuestionnaireEnableButton from "../../form/admin/AccountQuestionnaireEnableButton"
import AccountAuthConfigForm from "../../form/admin/AccountAuthConfigForm"
import QuestionnaireSettingsForm from "../questionnaire/QuestionnaireSettingsForm"
import { ToolDetailRow } from "../profile/ProfileTool"
import { format } from "date-fns"
import { Icons } from "../../../misc/Icons"
import { UTCDate } from "@date-fns/utc"


export default function ClientDetails () {

    const { sessionState, checkJwtRoles } = store.AppStore
    const { client, getClient, setClient, setTool } = store.ToolStore

    return (
        <>
            <div className="tool-section" style={{maxWidth: "700px"}}>
                <div className="tool-table">
                    <ToolDetailRow label={DisplayValue("dict_key", "accountName")}                  value={client.accountName} />
                    <ToolDetailRow label={DisplayValue("dict_key", "Organisation UID")}             value={client.advisorUid} />
                    <ToolDetailRow label={DisplayValue("dict_key", "accountType")}                  value={store.NodeStore.getDisplayType(client)} />
                    <ToolDetailRow label={DisplayValue("dict_key", "customerType")}                 value={DisplayValue("customer_type", client.customerType)} />
                    <ToolDetailRow label={DisplayValue("dict_key", "organisationType")}             value={DisplayValue("org_type", client.organisationType)} />
                    <ToolDetailRow label={DisplayValue("dict_key", "organisationActivity")}         value={DisplayValue("org_activity", client.organisationActivity)} />
                    <ToolDetailRow label={DisplayValue("dict_key", "phone")}                        value={client.phone} />
                    <ToolDetailRow label={DisplayValue("dict_key", "addressLine1")}                 value={client.addressLine1} />
                    <ToolDetailRow label={DisplayValue("dict_key", "city")}                         value={client.city} />
                    <ToolDetailRow label={DisplayValue("dict_key", "postcode")}                     value={client.postcode} />
                    <ToolDetailRow label={DisplayValue("dict_key", "countryId")}                    value={DisplayValue("countries", client.countryId)} />

                    {client.customerType === "N" ? (
                        <>
                            <ToolDetailRow label={DisplayValue("dict_key", "regulator")}                    value={DisplayValue("ni_regulator", client.regulator)} hidden={client.accountType !== "customer"} />
                            <ToolDetailRow label={DisplayValue("dict_key", "regulatorRegistrationNumber")}  value={client.regulatorRegistrationNumber} hidden={client.accountType !== "customer"} />                           
                        </>
                    ) : null}
                    
                    {client.accountType === "sponsor" ? (
                        <>
                            <ToolDetailRow label={DisplayValue("dict_key", "sponsorLicenceNum")}            value={client.sponsorLicenceNum} />
                            <ToolDetailRow label={DisplayValue("dict_key", "sponsorStartDate")}             value={client.sponsorStartDate ? format(new UTCDate(client.sponsorStartDate), "dd/MM/yyyy") : ""} />
                            <ToolDetailRow label={DisplayValue("dict_key", "sponsorExpiryDate")}            value={client.sponsorExpiryDate ? format(new UTCDate(client.sponsorExpiryDate), "dd/MM/yyyy") : ""} />
                        </>
                    ) : null}
                </div>
            </div>

            <div style={{display: "flex", gap: "10px", flexFlow: "wrap"}}>
                <Button
                    color="secondary"
                    variant="contained"
                    className="btn btn-sm"
                    onClick={() => {
                        store.ToolStore.setClient(null)
                        store.ToolStore.setTool(null)
                        store.ToolStore.setOpen(false)

                        store.NodeStore.setHomeNodeUid(client.uid)
                        store.NodeStore.setFolderNode(null)
                    }}>
                    Go to Workspace
                </Button>

                {IsAllowed(client, "UPDATE") ? (
                    <Button
                        color="secondary"
                        variant="contained"
                        className="btn btn-sm"
                        disabled={!!sessionState}
                        onClick={() => {
                            AlertModal({title: `Edit account`, body: (
                                <AccountEditForm
                                    account={client}
                                    onSuccess={() => {
                                        store.AlertStore.Close()
                                        getClient(client.uid)
                                    }}
                                />
                            )})
                        }}>
                        Edit account
                    </Button>
                ) : null}

                {!client.advisorUid ? (
                    <AccountQuestionnaireEnableButton
                        account={client}
                        onSuccess={() => store.ToolStore.getClient(client.uid)} />
                ) : null}

                {checkJwtRoles(["account_manager"]) && client.advisorUid ? (
                    <Button
                        color="secondary"
                        variant="contained"
                        className="btn btn-sm"
                        onClick={() => AlertModal({body: <QuestionnaireSettingsForm account={client} />, width: "550px"})}>
                        <Icons.Settings /> Questionnaire Settings
                    </Button>
                ) : null}

                {checkJwtRoles(["account_manager"]) ? (
                    <Button
                        color="error"
                        variant="contained"
                        className="btn btn-sm"
                        disabled={!!sessionState}
                        onClick={() => {
                            AlertModal({body: <AccountAuthConfigForm account={client} />, size: "auto"})
                        }}>
                        <Icons.Settings /> Authentication settings
                    </Button>
                ) : null}

                {checkJwtRoles(["account_manager"]) ? (
                    <Button
                        color="error"
                        variant="contained"
                        className="btn btn-sm"
                        disabled={!!sessionState}
                        onClick={() => {
                            AlertModal({body: <DeleteForm node={client} onSuccess={() => {
                                setTool(null)
                                setClient(null)
                                store.NodeStore.getAccounts()
                                store.NodeStore.navigateNode(null)
                            }} /> })
                        }}>
                        Delete account
                    </Button>
                ) : null}
            </div>

            {store.AppStore.checkJwtRole("account_manager") ? (
                <AccountUsers account={client} />
            ) : null}

            {/* {client.accountType === "sponsor" ? (
                <AccountJobs account={client} />
            ) : null} */}
        </>
    )
}